import { render } from "./TaskList.vue?vue&type=template&id=71e10c21&ts=true"
import script from "./TaskList.vue?vue&type=script&lang=ts"
export * from "./TaskList.vue?vue&type=script&lang=ts"
/* custom blocks */
import block0 from "./TaskList.scss?vue&type=custom&index=0&blockType=link&issuerPath=%2Fopt%2Fbuild%2Frepo%2Fsrc%2Fcomponents%2FTaskList.vue&scoped=true&lang=scss&external"
if (typeof block0 === 'function') block0(script)


import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__